import { timeOfBooking } from '@discover-lib/dateFormats';

export default function getSlotLabel(
  status: string,
  date: string,
  selectedDate: string | null,
  time?: string
) {
  if (status === 'available' && date === 'week' && !selectedDate) {
    return 'See times';
  }

  return (time && timeOfBooking(time)) || '-';
}
